import { Dictionary } from '@ngrx/entity';
import { JsonLdInterface } from '@techniek-team/api-platform';
import { jsonLdSelectId } from '../json-ld-select-id.function';
import { toDictionary } from './to-dictionary.function';

export function jsonldToDictionary<T extends JsonLdInterface>(objects: T[]): Dictionary<T> {
  return toDictionary<T>(objects, jsonLdSelectId);
}
